import { mapGetters } from 'vuex'

export default {
  name: 'EplNewPaymentModeCard',
  props: ['paymentMethod'],
  computed: {
    ...mapGetters(['paymentRequest', 'payableAmount'])
  },
  methods: {
    proceedToPay (paymentMode) {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "PAYMENT_METHOD_SELECTED",
        propertyName: "METHOD_NAME",
        propertyValue: paymentMode
      });
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "PAYMENT_METHOD_SELECTED",
        propertyName: "AMOUNT",
        propertyValue: this.payableAmount
      });
      this.$store.commit('setPaymentMethod', paymentMode)
      this.$store.dispatch('payNow', this.paymentRequest).then((response) =>
        window.open(
          response.paymentUrl, '_self')
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/EplNewPaymentModeCard/component.js